import { Suspense, useState, useEffect } from 'react'
import { Await, defer, Link, useSearchParams, useNavigate, useLoaderData, json } from 'react-router-dom'
import { project } from '../util/api'
import LoadingSpinner from './components/LoadingSpinner'
import Heading from './helper/Heading'
import { Title } from './helper/DocumentTitle'
import styles from '../styles/module/Project.module.scss'

export const loader = async () => {
  return defer({ project: project() })
}

export default function Project() {
  const pageName = 'پروژه های شهرداری'
  Title(pageName)

  const [loaderData, setLoaderData] = useState(useLoaderData())
  const [error, setError] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState([])
  const [showPopup, setShowPopup] = useState(false)
  let [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()

  const [filterYear, setFilterYear] = useState(searchParams.get(`year`) || '')
  const [completedFilter, setCompletedFilter] = useState(Boolean(searchParams.get(`completed`)) || '')

  useEffect(() => {
    document.querySelector('header span').innerText = pageName
  }, [])

  // Filter data based on year
  useEffect(() => {
    const fetchData = async () => {
      try {
        const resolvedData = await loaderData.project
        let filtered = resolvedData

        if (filterYear) {
          const year = parseInt(filterYear)
          filtered = resolvedData.filter((item) => {
            return startsWith(item.start_date, filterYear)
          })
        }

        setData(filtered)
      } catch (err) {
        setError(err.message)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [filterYear, loaderData])

  const handleYearChange = (e) => {
    const year = e.target.value
    setFilterYear(year)
    setSearchParams((prev) => {
      if (year) prev.set('year', year)
      else prev.delete('year')
      return prev
    })
  }

  const handleShowCompleted = (e) => {
    const isChecked = e.target.checked
    setCompletedFilter(!completedFilter)
    if (isChecked) {
      setSearchParams((prev) => {
        prev.set('completed', 'true')
        return prev
      })
    } else {
      setSearchParams((prev) => {
        prev.delete('completed')
        return prev
      })
    }
    //setFilterYear(year)
  }

  const renderField = (label, value) => {
    if (!value) return null
    return (
      <li>
        <label>{label}:</label>
        {value}
      </li>
    )
  }

  const renderProgressField = (item) => {
    if (!item.progress && !item.state) return null
    return (
      <li>
        <label>
          میزان پیشرفت (%{item.progress}) /<b>{item.state}</b>:
        </label>
        <div className={styles.meter}>
          <span style={{ width: `${item.progress}%` }}></span>
        </div>
      </li>
    )
  }
  // Simple contains check
  function contains(text, pattern) {
    return text.toLowerCase().includes(pattern.toLowerCase())
  }

  // Starts with
  function startsWith(text, pattern) {
    return text.toLowerCase().startsWith(pattern.toLowerCase())
  }

  // Ends with
  function endsWith(text, pattern) {
    return text.toLowerCase().endsWith(pattern.toLowerCase())
  }
  if (isLoading) return <LoadingSpinner />

  if (error) return <p>⚠️ Error: {error}</p>

  return (
    <section className={styles.section}>
      <div className="__frame" data-width={`xlarge`}>
        <div className={styles.filterContainer}>
          <div className="d-flex align-items-center grid--gap-1 flex-wrap" style={{ marginBottom: '1rem' }}>
            <label>فیلتر براساس سال شروع</label>
            <input type="number" value={filterYear} onChange={handleYearChange} placeholder="مثال: 1402" dir="ltr" style={{ width: '100px', marginLeft: '10px' }} />

            <div className="d-flex align-items-center">
              <input type="checkbox" name="completed" checked={completedFilter} id="completed" onChange={handleShowCompleted} style={{ cursor: 'pointer' }} />
              <label htmlFor="completed" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                مشاهده تکمیل شده‌ها
              </label>
            </div>

            <button
              onClick={() => {
                setFilterYear('')
                setSearchParams('')
              }}
              style={{ marginLeft: '10px' }}
            >
              پاک کردن فیلتر
            </button>
          </div>
        </div>

        <div className={styles.gridContainer}>
          <Suspense fallback={<LoadingSpinner />}>
            <Await resolve={loaderData.project} errorElement={<p>⚠️</p>}>
              {(data) => {
                let filteredData = filterYear ? data.filter((item) => startsWith(item.start_date, filterYear)) : data
                filteredData = completedFilter ? filteredData.filter((item) => item.progress === '100') : filteredData

                return filteredData.map((item) => {
                  return (
                    <div className={styles.gridItem} key={item.id}>
                      <div className={styles.item}>
                        <div className={styles.itemBody}>
                          {!item.video && (
                            <figure className={styles.gallery}>
                              <img src={`${process.env.REACT_APP_UPLOAD}images/${item.image}`} alt={item.name} />
                            </figure>
                          )}

                          {item.video && (
                            <div className={styles.videoContainer}>
                              <video width="100%" height={`250px`} controls>
                                <source src={item.video} type="video/mp4" />
                              </video>
                            </div>
                          )}

                          <ul>
                            {renderField('نام پروژه', item.name)}
                            {renderField('مجری', item.executive)}
                            {renderField('تاریخ شروع', item.start_date)}
                            {renderField('تاریخ اتمام', item.end_date)}
                            {renderField('بودجه اختصاص یافته', item.budget)}
                            {renderField('توضیحات', item.description)}
                            {renderProgressField(item)}
                          </ul>
                        </div>
                      </div>
                    </div>
                  )
                })
              }}
            </Await>
          </Suspense>
        </div>

        <Link to={`../`} className="button" style={{ maxWidth: '100px', margin: '1rem auto', position: 'absolute', bottom: '0', left: '50%', transform: 'translateX(-50%)' }}>
          بازگشت
        </Link>
      </div>
    </section>
  )
}
